import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useDashboard } from '../context/DashboardContext';

const Header = () => {
  const { isAuthenticated, currentUsername, logout, openAuthModal, isAdmin } = useAuth();
  const { setShowSettingsModal, currentCity, goHome, setShowHelpModal } = useDashboard();
  
  const handleUserBadgeClick = () => {
    if (isAdmin()) {
      // Use history API to avoid full page reload
      window.history.pushState({}, '', '/admin');
      window.dispatchEvent(new Event('navigation'));
    }
  };

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
      goHome();
    }
  };

  const handleOpenSettings = () => {
    if (!currentCity) {
      alert('Please select a city first to configure settings.');
      return;
    }
    setShowSettingsModal(true);
  };

  return (
    <header>
      <div className="logo">
        <div className="logo-group">
          <img src="/ndma-logo.png" alt="NDMA" className="logo-img" />
          <img src="/rmi_india_logo.png" alt="RMI India" className="logo-img logo-img-rmi" />
        </div>
        <span className="logo-divider" aria-hidden="true" />
        <span className="logo-text">
          HEAT IMPACT ASSESSMENT <span style={{ fontWeight: 300 }}>PLATFORM</span>
        </span>
      </div>
      
      {!isAuthenticated ? (
        <div className="auth-buttons">
          <button className="home-btn-header" onClick={goHome} title="Go to Home">
            Home
          </button>
          <button className="help-btn-header" onClick={() => setShowHelpModal(true)}>
            Help
          </button>
          <button className="login-btn" onClick={() => openAuthModal('login')}>
            Login
          </button>
        </div>
      ) : (
        <div className="user-info">
          <button className="home-btn-header" onClick={goHome} title="Go to Home">
            Home
          </button>
          <button className="settings-btn" onClick={handleOpenSettings}>
            Settings
          </button>
          <button className="help-btn-header" onClick={() => setShowHelpModal(true)}>
            Help
          </button>
          <div 
            className={`user-badge ${isAdmin() ? 'user-badge-clickable' : ''}`}
            onClick={handleUserBadgeClick}
            style={isAdmin() ? { cursor: 'pointer' } : {}}
            title={isAdmin() ? 'Click to open Admin Panel' : ''}
          >
            <div className="user-icon">👤</div>
            <span className="username">{currentUsername}</span>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;

